<template>
    <el-container >
        <el-header style="padding: 0">
            <el-row>
                <el-col :span="4" class="logo">
                <img src="@/../public/language_logo.png" style="width: 230px;height: 60px" />
                </el-col>
                <el-col :span="15">
                    <el-menu :default-active="headerActiveIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                             background-color="#545c64"
                             text-color="#fff"
                             active-text-color="#ffd04b"
                             style="padding: 0"
                    >
                        <!--<el-menu-item index="1" >首页</el-menu-item>-->
                        <template v-for="headMenu in headData">
                            <el-menu-item :index="headMenu.url" >{{headMenu.menuName}}</el-menu-item>
                        </template>
                    </el-menu>
                </el-col>
                <el-col :span="5" class="logo" align="right">
                    <i class="iconfont icon-blcu-user-login" style="color: white; margin-right: 15px"><span  v-if="user">{{user.realName}}</span></i>
                    <i class="icon-blcu-tuichu" title="退出登录" @click="logout" style="color: white; cursor: pointer;margin-right: 25px"></i>
                </el-col>
            </el-row>
            <el-dialog title="修改密码" :visible.sync="updatePassword" width="30%" :close-on-click-modal=false :before-close="handleDialogClose">
                <el-form ref="staffForm"  :model="form" :rules="rules" label-width="120px" class="demo-ruleForm" align="left">
                    <el-form-item  label="原密码:" prop="password" >
                        <el-input type="password"  v-model="form.password"  placeholder="密码(6-16位数字和字母组合)" ></el-input>
                    </el-form-item>
                    <el-form-item  label="新密码:" prop="password" >
                        <el-input type="password"  v-model="form.password"  placeholder="密码(6-16位数字和字母组合)" ></el-input>
                    </el-form-item>
                    <el-form-item  label="确认密码:" prop="password" >
                        <el-input type="password"  v-model="form.password"  placeholder="密码(6-16位数字和字母组合)" ></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="editPassword()">确 定</el-button>
                </div>
            </el-dialog>
        </el-header>
        <el-container>
        <el-aside  style="border: 5px solid #545c64; border-top: none">
        <el-menu
        text-color="#545c64"
        active-text-color="#ffd04b"
        :default-active="activeIndex"
        router
        ref="lefMenu"
        :default-openeds="openedsIds" 
         >
         <NavMenu :navMenus="menuData"></NavMenu>
        </el-menu>
        </el-aside>
        <el-main style="padding: 0; align-content: left;" ref="mainContent">
            <router-view style="margin-top: 10px;"></router-view>
        </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import NavMenu from "@/components/NavMenu.vue";
    import validate from '@/api/validate.js';
    const data1 = [
        {
            permissionId: 0,
            url: "dashboard",
            icon: "icon-blcu-home",
            menuName: "首页",
            children: []
        }];
    export default {
        name: "home",
        components: {
            NavMenu: NavMenu,
        },
      provide () {
        return {
          clientHeight: this.clientHeight
        }
      },
        data() {
            return {
                activeIndex: 'dashboard',
                headerActiveIndex: "1",
                menuData: JSON.parse(JSON.stringify(data1)),
                headData: [],
                leftMenus: {},
                clientHeight: "",
                updatePassword: false,
                user: {},
                form:{
                  password: '',
                },
              rules: {
                password: [
                  {required: true, message: '请输入密码', trigger: 'blur' },
                  { validator: validate.validatePassword, trigger: 'blur' }
                ],
              },
              openedsIds:["/system/system","/mall/courseCategory","review","commodity","package","order","comment","news","message","category","indexSetting"]
            };
        },
        mounted() {
            // 获取浏览器可视区域高度
            this.clientHeight = `${document.body.clientHeight}`
            //document.body.clientWidth;
            window.onresize = ()=> {
              this.clientHeight = `${document.body.clientHeight}`;
            };
        },
        watch: {
            'clientHeight': function(val) {
               this.changeFixed(val);
            },
        },
         methods: {
           editPassword() {
           
           },
           resetPWD() {
             this.updatePassword = true;
           },
           handleDialogClose() {
             this.updatePassword = false;
           },
           handleCommand(command) {
             if(command == "resetPWD") {
               this.resetPWD();
             }
             if(command == "logout") {
               this.logout();
             }
           },
            handleSelect(key) {
                if (key == 1) {
                    this.menuData = JSON.parse(JSON.stringify(data1));
                    this.headerActiveIndex = key
                    return;
                }
                this.menuData = this.leftMenus[key];
            },
            changeFixed(clientHeight) { //动态修改样式
                // console.log(this.$refs.homePage.$el.style.height);
                this.$refs.mainContent.$el.style.height = clientHeight - 65 + 'px';
                this.$refs.lefMenu.$el.style.height = clientHeight - 65 + 'px';
            },
         logout() {
                let params = {
                
                };
                let user = JSON.parse(localStorage.getItem("user"));

           this.https.fetchGet('/ssoLogin/logout/'+user.logoutId,params ).then((data) => {
                 let code = data.data.code;
                 let msg = data.data.msg;
                 if(code == '200') {
                     this.$router.push("/login");
                 } else {
                     this.$message({
                         type: 'info',
                         message: msg
                     });
                 }
             }).catch(err=>{
                     console.log(err)
                 }
             )
         },
        },
        created: function () {
        let params = {
            appId: "manager"
        };
        this.user = JSON.parse(localStorage.getItem("user"));
        let path = this.$route.path;
        let paths = path.substr(1).split("/");
        this.https.fetchPost('/managerPermission/selectMenuTree', params).then((data) => {
            let code = data.data.code;
            if (code == '200') {
                let menus = data.data.data
                this.headData = menus;
                let leftMenus = {};
                for (let index in menus) {
                    leftMenus[menus[index].url] = menus[index].children;
                    if (paths[0] == menus[index].url) {
                        this.menuData = menus[index].children;
                        this.headerActiveIndex = menus[index].url;
                        this.activeIndex = path;
                    }
                }
                this.leftMenus = leftMenus;
            }
        }).catch(err => {
                console.log(err)
            }
        )
    }
    }
</script>

<style scoped>
.logo {
    background: #545c64;
    height: 60px;
}
    .userinfo-inner {
        color: white;
        line-height: 60px;
        margin-right: 20px;
    }
</style>